
import React from "react";
import {DwollaFundingSourceStates} from "../../lib/dwolla/constants";
import {Action, Spinner} from "../funcs/utils";
import {OptionPopupButton} from "../components/BannerMenu/OptionPopupButton";
import {RemoveFundingSource, SetFundingSourceDefault} from "./actions";

const TitleValue = props => {
  const label_style = {
    fontSize: "1rem",
  }
  const value_style = {
    fontSize: "1.2rem",
    fontWeight: "600",
    color: props.default ? "#000" : "#AAA",
  }
  return (
    <div>
      <div style={label_style}>
        { props.title }
      </div>
      <div style={value_style}>
        { props.value }
      </div>
    </div>
  )
}

const last_4_digits = str => {
  let result = "";

  for(let i=0; i < str.length; i++) {
    if (i < str.length - 4) {
      result += "*";
    } else {
      result += str[i];
    }
  }
  return result;
}

const set_default_payment_source = (component, funding_source_id) => {

  SetFundingSourceDefault(
    component.props.token,
    component.props.onboarding_token,
    funding_source_id)
    .then(({dwolla}) => {
      component.setState({ source_loading: "" });
      component.props.dwollaUpdate(dwolla, 0);
      component.setState({dwolla});
    });
};

const remove_funding_source = (component, funding_source_id) => {
  component.setState({ source_loading: funding_source_id });

  RemoveFundingSource(
    component.props.token,
    component.props.onboarding_token,
    funding_source_id)
    .then(result => {
      const dwolla = result.dwolla;
      component.setState({ source_loading: "" });
      component.props.dwollaUpdate(dwolla, 0);
      component.setState({dwolla});
    })
};

const render_action_button = (component, funding_source_id, source, num_sources) => {
  const icon_style = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    paddingLeft: "0.5rem",
  }
  const icon_span = {
    display: "inline-block",
    transform: "translate(0, 0.3rem)",
  };
  const is_loading = component.state.source_loading === funding_source_id;

  console.log("is_loading", is_loading, "source_loading", component.state.source_loading);
  console.log("funding_source_id", funding_source_id);

  const buttons = [];

  if (!is_loading) {
    if (source.default && num_sources === 1) {
      buttons.push(
        { id: "remove", label: "Remove Account" });
    } else if (!source.default) {
      buttons.push(
        { id: "make_default", label: "Make Default" });
      buttons.push(
        { id: "remove", label: "Remove Account" });
    }
  }

  const action_style = {
    fontWeight: "bold",
  };
  if (source.default) {
    action_style.fontSize = "1.2rem";
  }
  /*if (buttons.length > 0) {
    action_style.fontWeight = "bold";
  } else {
    action_style.color = "#999";
  }*/

  const popup_style = {
    transform: "translate(-1rem, 0)",
    fontSize: "1rem",
  };
  const menu_button_style = {
    padding: "0.2rem 0.5rem",
    fontWeight: "bold",
    textAligh: "left",
  }
  const on_click = (menu_id, button_id) => {
    if (button_id === "make_default") {
      component.setState({ source_loading: funding_source_id });
      set_default_payment_source(component, funding_source_id);
    } else if (button_id === "remove") {
      remove_funding_source(component, funding_source_id);
    }

  };

  let text;
  if (is_loading) {
    text = (<Spinner/>);
  } else {
    if (source.default) {
      text = "Default";
    } else {
      text = "Action";
    }
  }

  return (
    <OptionPopupButton
      menu_id={"action"}
      popup_style={popup_style}
      on_click={on_click}
      buttons={buttons}
      menu_button_style={menu_button_style}
      button_style={{paddingRight: "1rem"}}>
      <div>
        <span style={action_style}>{ text }</span>
        <span style={icon_span}><i className="fa fa-angle-down" style={icon_style}/></span>
      </div>
    </OptionPopupButton>
  )
};

const PaymentSource = props => {
  const source = props.source;
  const num_sources = props.num_sources;
  const component = props.component;
  const suppress_action_button = props.suppress_action_button;

  const container_style = {
    padding: "1rem",
    margin: "1rem 0",
    border: "1px solid black",
  }

  let routing_acct = source.routing_number && source.account_number
    ? (
      <div style={{ display: "flex", marginTop: "1rem"}}>
        <div style={{flex: "1"}}>
          <TitleValue
            title={"ABA/Routing Number"}
            value={last_4_digits(source.routing_number)}
            default={source.default}/>
        </div>
        <div style={{flex: "1"}}>
          <TitleValue
            title={"Account Number"}
            value={last_4_digits(source.account_number)}
            default={source.default}/>
        </div>
      </div>
    )
    : null;

  let microdep_line;

  const on_verify = (source_id) => () => {
    component.setState({
      verify_micropayments_popup: source_id,
      verify_micropayments_error: "",
      highlight_rects: [],

    });
  }

  if (source.state === DwollaFundingSourceStates.UNVERIFIED
    && source.events
    && source.events.customer_microdeposits_completed) {
    const text = "** Two microdeposits were sent to your account. **";
    microdep_line = (
      <div>
        <div style={{ display: "flex", marginTop: "1rem", justifyContent: "center"}}>
          <div>{text}</div>
        </div>
        <div style={{ display: "flex", marginTop: "1rem", justifyContent: "center"}}>
          <Action onClick={on_verify(source.id)}>Verify Microdeposits</Action>
        </div>
      </div>
    );
  } else if (source.state === DwollaFundingSourceStates.UNVERIFIED
    && source.events
    && source.events.customer_microdeposits_added) {
    const text = "** Microdeposits are pending **";
    microdep_line = (
      <div style={{ display: "flex", marginTop: "1rem", justifyContent: "center"}}>
        <div>{text}</div>
      </div>
    )
  }

  return (
    <div style={container_style}>
      <div style={{display: "flex"}}>
        <div style={{ flex: "1"}}>
          <TitleValue
            title={"Account Name"}
            value={source.name}
            default={source.default}/>
        </div>
        <div style={{flex: "1"}}>
          <div style={{display: "flex"}}>
            <div style={{flex: "1"}}>
              <TitleValue
                title={"Bank"}
                value={source.bank_name}
                default={source.default}/>
            </div>
            { !suppress_action_button && <div>
              { render_action_button(component, source.id, source, num_sources) }
            </div> }
          </div>
        </div>
      </div>
      { routing_acct }
      { microdep_line }
    </div>
  );
}

export  { PaymentSource };
